import styled from 'styled-components';

export const ContainerFile = styled.div`
  width: 100%;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 6px;
  align-items: center;
  justify-content: center;
  padding: 14px;
  border-radius: 10px;
  border: 1px dashed #cbd5e1;
  background: #fff;

  input {
    display: none;
  }

  .icon {
    margin-bottom: 6px;
  }

  &:hover {
    background: #f9fafb;
  }
`;